'use client';

/**
 * src/components/ModoApp.jsx
 *
 * Páginas que la app abre en su navegador interno (Términos, Privacidad,
 * recuperar contraseña) traían «← Volver al sitio» → la landing con precios y
 * checkout de Stripe: riesgo 3.1.1 en App Review (auditoría 2026-10-21). La app
 * las abre con ?app=1; esto marca <html data-en-app="1"> (y lo recuerda en la
 * pestaña) para que el CSS esconda todo lo marcado con .ocultarEnApp.
 */

import { useEffect } from 'react';

export default function ModoApp() {
  useEffect(() => {
    let enApp = false;
    try {
      enApp = new URLSearchParams(window.location.search).get('app') === '1'
        || window.sessionStorage.getItem('dv_en_app') === '1';
      if (enApp) window.sessionStorage.setItem('dv_en_app', '1');
    } catch { /* storage bloqueado: solo el parámetro */ }
    if (enApp) document.documentElement.dataset.enApp = '1';
  }, []);
  return <style>{'html[data-en-app="1"] .ocultarEnApp{display:none !important}'}</style>;
}
